export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";
export const DELETE_LOGIN_ERROR = "DELETE_LOGIN_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";
export const CLEAR_FORGOT_PASSWORD_MESSAGE = "CLEAR_FORGOT_PASSWORD_MESSAGE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const CLEAR_CHANGE_PASSWORD_MESSAGE = "CLEAR_CHANGE_PASSWORD_MESSAGE";
export const SIGNIN = "SIGNIN";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILED = "SIGNIN_FAILED";
export const SIGN_IN_GUEST = "SIGN_IN_GUEST";
export const SIGN_IN_GUEST_SUCCESS = "SIGN_IN_GUEST_SUCCESS";
export const SIGN_IN_GUEST_FAILED = "SIGN_IN_GUEST_FAILED";
export const CLEAR_ERROR_AND_SUCCESSFUL = "CLEAR_ERROR_AND_SUCCESSFUL";
export const SET_USER_INFO = "SET_USER_INFO";
